
<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('admission_management.published_circular') }} {{ $t('globalTrans.search') }}</h4>
            </template>
            <template v-slot:body>
                <b-row>
                    <b-col xl="6" lg="6" md="6" sm="12" xs="12">
                      <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="year"
                      >
                        <template v-slot:label>
                          {{$t('globalTrans.year')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="search.year"
                          :options="yearList"
                          id="year"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6" sm="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="organiation_id"
                            >
                            <template v-slot:label>
                                {{$t('globalTrans.organization')}}
                            </template>
                            <b-form-select
                            plain
                            v-model="search.org_id"
                            :options="orgList"
                            id="organiation_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :disabled="$store.state.Auth.authUser.role_id === 1 ? false : true" :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" sm="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="office_type_id"
                            >
                            <template v-slot:label>
                                {{$t('child_configuration.institute_type')}}
                            </template>
                            <b-form-select
                            plain
                            v-model="search.office_type_id"
                            :options="officeTypeList"
                            id="office_type_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" sm="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="office_id"
                            >
                            <template v-slot:label>
                                {{$t('child_configuration.institute_name')}}
                            </template>
                            <b-form-select
                            plain
                            v-model="search.office_id"
                            :options="officeList"
                            id="office_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col >
                      <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
    <!-- /Search Form -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <!-- Add New -->
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('admission_management.published_circulars') + ' ' + $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <!-- Table -->
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(status)="data">
                        <span class="badge badge-success" v-if="data.item">
                            {{$t('globalTrans.published')}}
                        </span>
                    </template>
                    <template v-slot:cell(action)="data">
                        <b-button v-b-modal.modal-detail variant=" iq-bg-success mr-1 mb-1" title="View Details" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0"></i></b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
     <b-modal id="modal-detail" size="lg" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId" :key="editItemId" :url="dataurl"/>
    </b-modal>
  </b-container>
</template>
<script>
import DetailModal from './DetailModal'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { approveOrPublishListApi, circularApproveDenyApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import { mapGetters } from 'vuex'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    DetailModal
  },
  data () {
    return {
      search: {
        year: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        is_published: 1
      },
      editItemId: 0,
      officeTypeList: [],
      officeList: [],
      userList: [],
      dataurl: disabilitySchoolServiceBaseUrl
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'Auth/authUser'
    }),
    yearList: function () {
      return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item, text: this.$n(item, { useGrouping: false }) }
        } else {
          return item
        }
      })
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    detailTitle () {
        return this.$t('admission_management.published_circulars') + ' ' + this.$t('globalTrans.details') + ' ' + this.$t('sidebar.information')
    },
    columns () {
      const labels = [
           { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('child_admission_management.institute_name'), class: 'text-left' },
          { label: this.$t('admission_management.circular_name'), class: 'text-center' },
          { label: this.$t('production_store.employee_name'), class: 'text-left' },
          { label: this.$t('production_store.designation'), class: 'text-left' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'institute_name_bn' },
          { key: 'circular_name_bn' },
          { key: 'employee_name_bn' },
          { key: 'designation_bn' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'institute_name' },
          { key: 'circular_name' },
          { key: 'employee_name' },
          { key: 'designation' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
       this.getOfficeTypeList()
    },
    'search.office_type_id': function (newVal, oldVal) {
       this.getOfficeList()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
            }
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
      this.loadData()
  },
  methods: {
    details (item) {
      this.editItemId = item.id
    },
    searchData () {
      this.loadData()
    },
    approveDeny (item, status) {
        let swalMsg = ''
        if (status === 1) {
            swalMsg = window.vm.$t('globalTrans.publishMsg')
        }
        window.vm.$swal({
                title: swalMsg,
                showCancelButton: true,
                confirmButtonText: window.vm.$t('globalTrans.yes'),
                cancelButtonText: window.vm.$t('globalTrans.no'),
                focusConfirm: false
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch('mutateCommonProperties', { loading: true })
                    const loadingState = { loading: false, listReload: true }
                    if (item.id) {
                        RestApi.putData(disabilitySchoolServiceBaseUrl, `${circularApproveDenyApi}/${item.id}/${status}`).then(response => {
                        this.$store.dispatch('mutateCommonProperties', loadingState)
                            if (response.success) {
                                this.$store.commit('DisabilitySchoolService/mutateCommonObj', { hasDropdownLoaded: false })
                                this.$toast.success({
                                    title: this.$t('globalTrans.success'),
                                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save'),
                                    color: '#D6E09B'
                                })
                            }
                        })
                    }
                }
            })
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(disabilitySchoolServiceBaseUrl, approveOrPublishListApi, params).then(response => {
        if (response.success) {
          this.userList = response.userDetails
          this.$store.dispatch('setList', this.getRelationalData(response.data.data))
          this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
  getRelationalData (data) {
      let tmpInstitute = {}
      let tmpOrgList = {}
      let tmpOfficeTypeList = {}
      let tmpEmployee = {}
      const listData = data.map(item => {
          tmpEmployee = this.userList.find(user => user.value === item.created_by)
          tmpOfficeTypeList = this.$store.state.commonObj.officeTypeList.find(officeType => officeType.value === item.office_type_id)
          tmpInstitute = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id)
          tmpOrgList = this.$store.state.commonObj.organizationProfileList.find(org => org.value === item.org_id)
          const admissionData = {
              institute_name: tmpInstitute !== undefined ? tmpInstitute.text_en : '',
              institute_name_bn: tmpInstitute !== undefined ? tmpInstitute.text_bn : '',
              office_type: tmpOfficeTypeList !== undefined ? tmpOfficeTypeList.text_en : '',
              office_type_bn: tmpOfficeTypeList !== undefined ? tmpOfficeTypeList.text_bn : '',
              org_en: tmpOrgList !== undefined ? tmpOrgList.text_en : '',
              org_bn: tmpOrgList !== undefined ? tmpOrgList.text_bn : '',
              employee_name: tmpEmployee !== undefined ? tmpEmployee.text_en : '',
              employee_name_bn: tmpEmployee !== undefined ? tmpEmployee.text_bn : '',
              designation_id: tmpEmployee !== undefined ? tmpEmployee.designation_id : ''
          }
          const tmpDesignation = this.$store.state.commonObj.designationList.find(designation => designation.value === admissionData.designation_id)
          const designationData = {
              designation: tmpDesignation !== undefined ? tmpDesignation.text_en : '',
              designation_bn: tmpDesignation !== undefined ? tmpDesignation.text_bn : ''
          }
          return Object.assign({}, item, admissionData, designationData)
      })
      return listData
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getNameReceiver (id) {
      const userName = this.userList.find(user => user.value === id)
      if (this.$i18n.locale === 'bn') {
        return userName.text_bn
      } else {
        return userName.text_en
      }
    }
  }
}
</script>
